export default __webpack_public_path__ + "assets/images/Landing_page_logo3.ff6ef514.svg";